// extracted by mini-css-extract-plugin
export default {"watchVideoWrapper":"watchVideoModal_watchVideoWrapper__DT5Yk","watchVideo":"watchVideoModal_watchVideo__GF5i1"};